import {_} from 'lodash';
import {IMessage, IRuleset} from '../../index';
import {global} from '../../appContext';

/** Fetch full ruleset, update name only, persist via updateruleset. */
export async function saveRulesetName(item: IRuleset, newName: string): Promise<void> {
    const reqGet = global.getPromiseRequest('getruleset');
    const data = await reqGet.request({id: item.id}) as IRuleset[];
    const ruleset = data?.[0];
    if (!ruleset) {
        throw new Error('ruleset not found');
    }

    const payload = _.cloneDeep(ruleset);
    payload.name = newName;
    delete (payload as Partial<IRuleset>).rules;

    const reqUpdate = global.getPromiseRequest('updateruleset');
    await reqUpdate.request({jruleset: JSON.stringify(payload)});

    global.cacheManager.removeCache('getruleset');
    global.cacheManager.removeCache('searchruleset');
}

/** Fetch full message flow, update name only, persist via updatemessage. */
export async function saveMessageFlowName(item: IMessage, newName: string): Promise<void> {
    const reqGet = global.getPromiseRequest('getmessage');
    const data = await reqGet.request({id: item.id}) as IMessage[];
    const message = data?.[0];
    if (!message) {
        throw new Error('message flow not found');
    }

    const payload = _.defaultsDeep({
        name: newName,
        messagelog: null,
    }, _.cloneDeep(message)) as IMessage;
    payload.body = encodeURIComponent(payload.body ?? '');

    const reqUpdate = global.getPromiseRequest('updatemessage');
    await reqUpdate.request({jmessage: JSON.stringify(payload)});

    global.cacheManager.removeCache('getmessage');
    global.cacheManager.removeCache('searchmessage');
    global.cacheManager.removeCache('getruleset');
    global.cacheManager.removeCache('searchruleset');
}
